<template>
  <div style="margin: 0 0 24px;">
    <div style="display: flex; align-items: center">
<!--      <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 340px;height: 340px;margin: 0 auto">-->
      <el-image v-if="src" style="width: 340px;height: auto;margin: 0 auto; cursor: pointer" fit="cover" :src="src" @click="headImgUpdate" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      <div class="add" @click="headImgUpdate" v-else>
        <span>+</span>
      </div>
      <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button type="danger" @click.native="delImg" v-if="src" v-loading="delLoading">删除</el-button>
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { updateCashbackRemitImg, getSysPositionList } from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      cashbackForm: this.value.cashbackForm,

      files: null,
      src: this.value.cashbackForm.remitImg,

      loading: false,
      delLoading: false

    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '照片不能为空',
          type: 'warning'
        });
        return false
      }

      this.loading = true
      let param = new FormData();
      param.append('id', this.cashbackForm.id);
      param.append('file', this.files);
      param.append('type', 1);

      imgPostFormData(updateCashbackRemitImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', this.src)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },

    delImg() {
      this.$confirm('确定删除图片？').then(()=>{
        this.delLoading = true
        let param = new FormData();
        param.append('id', this.cashbackForm.id);
        param.append('type', 2);

        imgPostFormData(updateCashbackRemitImg, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm', '')
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          this.delLoading = false
        })
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 340px;
  height: 340px;
  text-align: center;
  line-height: 340px;
  border: 2px dashed #ececec;
  font-size: 40px;
  cursor: pointer;
  margin: 0 auto
}
</style>
